module.exports = __webpack_public_path__ + "img/control-centre-logo-full.76144f5a.svg";